import FileSaver from "file-saver";
import { restClient } from "@/lib/raftApi";

// eslint-disable-next-line import/prefer-default-export
export function useNotificationActions() {
  async function downloadOrVisit(destination, job = {}) {
    if (destination.hasOwnProperty("path")) {
      const fileData = await restClient.downloadFile(destination.path);
      FileSaver.saveAs(
        new Blob([fileData]),
        job?.field_sds_zip_file?.filename ?? "download.zip",
      );
    } else {
      window.location.href = destination;
    }
  }
  return { downloadOrVisit };
}
